import { Middleware, } from '@spotify-internal/remote-config-core';
import { createEventSender } from '@spotify-internal/event-sender';
import { exposureMiddleware as granularExposure, } from './exposure';
import { errorExposureMiddleware } from './error-exposure';
import { consentExposureMiddleware } from './consent-exposure';
let trackjs;
try {
    trackjs = require('@spotify-internal/track-js');
}
catch (e) {
}
const composedExposureMiddleware = Middleware.compose(granularExposure, errorExposureMiddleware);
const composedExposureWithConsentMiddleware = Middleware.compose(consentExposureMiddleware, composedExposureMiddleware);
export function exposureMiddleware(next) {
    let exposureMiddleware;
    if (!trackjs) {
        exposureMiddleware = composedExposureMiddleware;
    }
    else {
        exposureMiddleware = composedExposureWithConsentMiddleware;
    }
    const withNext = exposureMiddleware(next);
    return options => {
        const { eventSender = createDefaultEventSender(options.transport) } = options;
        const withOptions = withNext(Object.assign(Object.assign({}, options), { eventSender }));
        return ctx => {
            return withOptions(ctx);
        };
    };
}
function createDefaultEventSender(transport) {
    if (!transport)
        throw new Error(`Either "transport" or "eventSender" must be provided.`);
    return createEventSender({ transport });
}
//# sourceMappingURL=index.js.map